module.exports = __webpack_public_path__ + "img/pc8.c8c3029b.png";